import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { ConstructDestinationUrl } from "../construct-destination-url";

export const LiveIntent = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all <b>destination URLs</b> for new
      and existing ads.
    </p>
    <ConstructDestinationUrl platform={NorthbeamUtmPlatform.LIVE_INTENT} />
    <p className="mb-0">
      Follow the instructions{" "}
      <GenericExternalLink href="https://support.liveintent.com/hc/en-us/articles/360000822966-Click-URL-Macros-and-Accepted-Characters">
        here
      </GenericExternalLink>{" "}
      to edit or create a new ad with Northbeam&apos;s URL parameters. The link
      you copied above will be valid in <b>LiveIntent</b>.
    </p>
  </div>
);
